//This is a hardcoded model from the generated code, I don't believe it should change very often, so its probably fine... :)
export enum ProfessionType {
  Physician = 'Physician',
  Other = 'Other'
}
